import { FEATURES } from '@/constants/features';

export const ENGAGE_CONFIG_PAGE = 'market_overview';
export const ENGAGE_DEFAULT_CONFIG_TAB = 'Partners';

export const ENGAGE_TABS = [
  { key: 'partners', label: 'Partners', path: '/engage/partners', name: 'Engage', configTab: 'Partners', meta: { canAccess: FEATURES.MODULE_ENGAGE } },
  { key: 'engagements', label: 'Engagements', path: '/engage/engagements', name: 'Engage - Engagements', configTab: 'Engagements', meta: { canAccess: FEATURES.MODULE_ENGAGE } },
  { key: 'transform', label: 'Transform', path: '/engage/transform', name: 'Engage - Transform', meta: { canAccess: FEATURES.MODULE_MANAGE } },
  { key: 'projects', label: 'Projects', path: '/engage/projects', name: 'Engage - Projects', meta: { canAccess: FEATURES.MODULE_MANAGE } },
  { key: 'intelligence', label: 'Intelligence', path: '/engage/intelligence', name: 'Engage - Intelligence', meta: { canAccess: FEATURES.MODULE_MANAGE } },
  { key: 'surveys', label: 'Surveys', path: '/engage/surveys', name: 'Engage - Surveys', meta: { canAccess: FEATURES.MODULE_MANAGE } },
  { key: 'network-map', label: 'Network Map', path: '/engage/network-map', name: 'Engage - Network Map', meta: { canAccess: FEATURES.MODULE_NETWORK_MAP } },
];
